import { appConstants } from "../_constants";
import { initialState } from "../_store";

export function setView(state = initialState.setView, action) {

    switch (action.type) {
        case appConstants.SET_VIEW:
            return action.view;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/setView.reducer.js